import { render, staticRenderFns } from "./JTable.vue?vue&type=template&id=c903565e&"
import script from "./JTable.vue?vue&type=script&lang=js&"
export * from "./JTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports